<template>
   <div>
     <v-collapse-wrapper :active="true">
       <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
            v-collapse-toggle>
         <h3>Все изменения по редактированию</h3>
       </div>

       <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
         <div class="a-ui-tab u-margin-b-24">
           <div class="a-ui-tab__block">
             <div class="a-ui-tab__content-block">
               <section v-maximizable>
                <div class="table-tab">
                 <div class="table-tab__container">
                   <table class="table-tab__block table ">
                     <thead class="table-tab__thead table-tab__border-bottom">
                       <tr class="">
                         <th>№</th>
                         <th>Роль</th>
                         <th>ФИО (электронная подпись)</th>
                         <th>Дата и время подписания</th>
                         <th>Наименование раздела</th>
                         <th>Дата и время окончания редактирования</th>
<!--                         <th>Предложение, измененное</th>-->
                         <th>Отправленное сообщение по предложению Организатором участникам</th>
                       </tr>
                     </thead>

                     <tbody>
                      <tr v-for="(item, idx) of history" :key="`+${item.time}-${idx}`">
                        <th>{{idx + 1}}</th>
                        <th>{{$t(item.role.label)}}</th>
                        <th>{{item.author}}</th>
                        <th><date-time tag="span" :value="item.time" :tz="false"></date-time></th>
                        <th>
                          {{$t(item.changedSection.label)}}
                          <span v-if="item.criterion">
                            : {{item.criterion.type === 'Price' ? 'Вспомогательные ценовые': 'Экспертнооцениваемые'}}
                          </span>
                        </th>
                        <th>
                          <date-time :value="item.till"></date-time>
                        </th>
<!--                        <th>-->
<!--                          <template v-if="currentUserId !== request.owner.id">-->
<!--                            <router-link class="table-tab__color u-text-underline"-->
<!--                                         v-if="item.bidNum"-->
<!--                                         :to="{-->
<!--                                         name: 'purchases-public-lot-alien-bid',-->
<!--                                         params: {-->
<!--                                           lotId: lot.id, requestId: request.id, bidId: `num-${item.bidNum}`, tab: 'bid'}-->
<!--                                       }">-->
<!--                              {{lot.catalog.name}} - {{request.id}} - {{item.bidNum}}-->
<!--                            </router-link>-->
<!--                            <router-link class="table-tab__color u-text-underline"-->
<!--                                         v-else-->
<!--                                         :to="{-->
<!--                                         name: 'purchases-public-lot-alien-bid',-->
<!--                                         params: {-->
<!--                                           lotId: lot.id,-->
<!--                                           requestId: request.id,-->
<!--                                           tab: 'request'}-->
<!--                                         }">-->
<!--                              {{lot.catalog.name}} - {{request.id}}-->
<!--                            </router-link>-->
<!--                          </template>-->


<!--                          <template v-else>-->
<!--                            <router-link class="table-tab__color u-text-underline"-->
<!--                                         :to="{-->
<!--                                         name: 'purchases-my-lots-details',-->
<!--                                         params: {-->
<!--                                           lotId: lot.id,-->
<!--                                           tab: `bidnum-${item.bidNum}`-->
<!--                                         }-->
<!--                                       }">-->
<!--                              {{lot.catalog.name}} - {{request.id}} - {{item.bidNum}}-->
<!--                            </router-link>-->
<!--                          </template>-->
<!--                        </th>-->
                        <th>{{item.description}}</th>
                      </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
               </section>
             </div>
           </div>
         </div>
       </div>
     </v-collapse-wrapper>
   </div>
</template>

<script>
  import _ from 'lodash'
  import Pagination from '@/components/pagination/Pagination'

  export default {
    props: {
      lot: Object,

      request: Object,

      bidNum: {
        type: Number,
        default: 0
      }
    },

    computed: {
      currentUserId() {
        return this.$store.getters.currentUser.id
      },

      history() {
        return this.request.history.filter(h => h.bidNum === this.bidNum);
      }
    }
  }
</script>

<style scoped>

</style>
